import { MetadataResponse } from 'services/api/pos/products/types-update-metadata';

import { get } from './base';

export const MetadataAPI = {
  index: async (): Promise<MetadataResponse> => {
    return get('v5/metadata').json<MetadataResponse>();
  },
};
